import componentInitializer from "@/frontend/utils/componentInitializer"

componentInitializer(() => {
  if (window.location.pathname.includes("/Artwork/")) {
    initPhotoSwipe($("#product-gallery"), false)

    if (document.body.dataset.isMobile === "false") {
      initStickyCartDesktop()
    }
  }
})

function updateStickyCartTop(btn) {
  const navbar = document.getElementById("main-navbar")
  if (navbar && btn) {
    btn.style = `top: ${navbar.clientHeight}px`
  }
}

function initStickyCartDesktop() {
  const btn = document.getElementById("product-sticky-add-to-cart")
  const navbar = document.getElementById("main-navbar")
  const observableSection = document.querySelector(".sticky-add-cart-observable")

  let lastNavbarHeight = 0

  const resizeObserver = new ResizeObserver((entries) => {
    // update sticky "Add to Cart" position when navbar height changes
    for (const entry of entries) {
      if (entry.target.id === "main-navbar") {
        const newHeight = entry.contentRect.height
        if (newHeight !== lastNavbarHeight) {
          lastNavbarHeight = newHeight
          updateStickyCartTop(btn)
        }
      }
    }
  })

  if (navbar && btn) {
    resizeObserver.observe(navbar)
  } else {
    resizeObserver.unobserve(navbar)
  }

  if (!window.location.pathname.includes("/Artwork/")) {
    resizeObserver.disconnect()
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // the main "Add to Cart" button is visible - hide sticky button
          btn.classList.add("hidden")
        } else {
          // the main "Add to Cart" button is NOT visible - show sticky button
          btn.classList.remove("hidden")
        }
      })
    },
    { root: null, rootMargin: "0px", threshold: 0 },
  )

  if (observableSection) {
    observer.observe(observableSection)
  } else {
    observer.unobserve(observableSection)
  }
}
